import { BackButton } from '@/components/BackButton';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './VoucherPage.module.scss';
import banner from '../../../public/bannerVoucher.webp';
import arrow from '../../assets/Icons/master.svg?url';
import { ReactComponent as VoucherLogo } from '../../assets/Icons/voucherLogo.svg';
import { activateVoucher } from '@/api/modules/Voucher/voucher';
import { useNotificationStore } from '@/store/NotificationStore';
import { Loader } from '@/components/Loader/Loader';
import VoucherConditionItem from './VoucherConditionItem';

const VoucherPage = () => {
  const tg = window.Telegram?.WebApp;
  const [voucher, setVoucher] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [conditions, setConditions] = useState<any[]>([]);
  const [voucherData, setVoucherData] = useState<any>(null);
  const [bannerLoaded, setBannerLoaded] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const navigate = useNavigate();
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );
  useEffect(() => {
    useNavMenuStore.getState().setVisibility(false);

    return () => {
      useNavMenuStore.getState().setVisibility(true);
    };
  }, []);

  const handleBackClick = () => {
    navigate('/');
  };

  const handleHistoryClick = () => {
    navigate('/voucher/history');
  };

  const handleActivate = async () => {
    setIsLoading(true);
    try {
      const res = await activateVoucher(voucher);
      console.log(res);
      if (res.success === false) {
        setConditions(res.user_conditions);
        setVoucherData(res);
      } else {
        setNotification({
          message: `Промокод успешно активирован.`,
          type: 'Success',
          rewards: [
            {
              amount: res.reward.amount,
              type: res.reward.type,
            },
          ],
        });
        setConditions([]);
        setVoucherData(null);
        setVoucher('');
      }
    } catch (error: any) {
      if (error.response?.data?.detail === 'Voucher not found') {
        setNotification({
          message: 'Ваучер не найден или закончился.',
          type: 'Error',
        });
        setConditions([]);
        setVoucherData(null);
      }
      if (error.response?.data?.detail === 'Voucher already activated') {
        setNotification({
          message: 'Ваучер уже активирован',
          type: 'Error',
        });
        setConditions([]);
        setVoucherData(null);
      }
      if (error.response?.data?.detail === 'Voucher limit reached"') {
        setNotification({
          message: 'Лимит активации промокода достигнут',
          type: 'Error',
        });
        setConditions([]);
        setVoucherData(null);
      }
      if (error.status === 433) {
        setNotification({
          message: error.response?.data?.detail || 'Ошибка активации ваучера',
          type: 'Error',
        });
        setConditions([]);
        setVoucherData(null);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleReadMore = () => {
    tg?.openTelegramLink('https://t.me/stars_sheikh/30');
  };

  return (
    <div className={styles.container}>
      {!bannerLoaded && (
        <div className={styles.pageLoader}>
          <Loader />
        </div>
      )}
      <BackButton onClick={handleBackClick} />
      <div className={styles.content}>
        <div
          className={styles.banner}
          style={{
            backgroundImage: `url(${banner})`,
          }}
        >
          <img
            src={banner}
            alt=""
            style={{ display: 'none' }}
            onLoad={() => setBannerLoaded(true)}
          />
          <div className={styles.historyButton} onClick={handleHistoryClick}>
            <div>История</div>
            <img src={arrow} alt="" />
          </div>
          <div className={styles.voucherTitle}>
            <div>Вводи - Активируй - Получай.</div>
          </div>
        </div>
        <div className={styles.inputVoucher}>
          <div className={styles.voucherInput}>
            <VoucherLogo className={styles.voucherIcon} />
            <input
              className={styles.voucherField}
              type="text"
              placeholder="Промокод"
              value={voucher}
              onChange={(e) => setVoucher(e.target.value)}
              onFocus={() => setIsInputFocused(true)}
              onBlur={() => setIsInputFocused(false)}
              inputMode="text"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
            />
          </div>
        </div>
        {voucherData ? (
          <div className={styles.voucherConditions}>
            Чтобы активировать данный промокод, <br /> выполни следующие
            условия:
          </div>
        ) : (
          <>
            {!isInputFocused && (
              <div className={styles.voucherStartInfoContainer}>
                <div className={styles.voucherStartInfo}>
                  Для некоторых промокодов <br /> могут быть дополнительные
                  условия.
                </div>
                <button
                  onClick={handleReadMore}
                  className={styles.voucherStartButton}
                >
                  Читать подробнее
                </button>
              </div>
            )}
          </>
        )}
        <div className={styles.conditionList}>
          {conditions.map((condition): any => (
            <VoucherConditionItem
              key={condition.condition_id}
              condition={condition}
              voucher_id={voucherData?.voucher_id}
            />
          ))}
        </div>
        <div className={styles.voucherButton}>
          <button
            onClick={handleActivate}
            className={styles.button}
            disabled={isLoading || !voucher}
          >
            {isLoading ? (
              <div className={styles.voucherLoader} />
            ) : (
              'Активировать!'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default VoucherPage;
